import * as React from 'react';
import { ReactElement, ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';
import { Colors } from '../../../types/colors';

// Extends the standard <p> attributes because the component spreads `...props`
// straight onto the element.
type IProps = {
  children: ReactNode;
  color?: Colors;
  className?: string;
  style?: React.CSSProperties;
} & Omit<React.HTMLAttributes<HTMLParagraphElement>, 'color'>;

const Body = ({
  children,
  color = 'blue',
  className,
  ...props
}: IProps): ReactElement => {
  return (
    <p
      // `body-flow` is the one part with no utility equivalent: consecutive
      // Body paragraphs get a 16px gap via an adjacent-sibling rule. It is an
      // @utility in src/styles/utilities.css.
      className={twMerge(
        'body body-flow text-xl leading-normal',
        `text-type-${color}`,
        className
      )}
      {...props}>
      {children}
    </p>
  );
};

export default Body;
